import { IsBoolean, IsNotEmpty, IsUUID, ValidateNested } from 'class-validator';
import { BaseCreateDto, BaseDto } from '../base.dto';
import { BaseConsentDto } from './health-record-consent.dtos';
import { Type } from 'class-transformer';

export interface MedicalUnitConsentDto extends BaseDto, BaseConsentDto {
  medicalUnitId: string;
}

export class CreateMedicalUnitConsentDto
  extends BaseCreateDto
  implements Partial<MedicalUnitConsentDto>
{
  @IsNotEmpty()
  @IsBoolean()
  consented: boolean;

  @IsNotEmpty()
  @IsUUID()
  consentRevisionId: string;

  @IsNotEmpty()
  @IsUUID()
  medicalUnitId: string;
}

export class CreateManyMedicalUnitConsentsDto {
  @Type(() => CreateMedicalUnitConsentDto)
  @ValidateNested({ each: true })
  medicalUnitConsents: CreateMedicalUnitConsentDto[];
}
